import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import PropTypes from 'prop-types'

import AboutUs from './about-us'
import MobileReviews from './apprentus-reviews/mobile-reviews'
import AboutApprentus from './about-apprentus'
import NewsletterSubscribe from './newsletter-subscribe'
import FollowUs from './follow-us'
import DesktopReviews from './apprentus-reviews/desktop-reviews'
import InviteFriends from '~/scenes/footer/invite-friends'
import MobileAllCountries from './all-countries/mobile-all-countries'
import MobileAllCities from './all-cities/mobile-all-cities'
import UnderFooter from './under-footer'
import Press from './press'

import railsContext from 'lib/selectors/rails-context'

import footerLogic from './logic'

const MAX_SMALL_WIDTH = 631

const Footer = ({
  showPress,
  pages,
  aboutApprentus,
  socialMediaIcons,
  reviews,
  inviteFriends,
  subscribeUrl,
  allCountries,
  onlineCategories,
  allCities,
  isLoggedIn
}) => {
  const { pageKeyword, isFullScreenFiltersPage, isFullScreenMap } = useValues(footerLogic)
  const { startFullscreen, scene } = useSelector(railsContext)

  const isMobile = useMediaQuery({ maxWidth: MAX_SMALL_WIDTH })
  const isCourseShowPage = scene === 'courseShow'
  const underFooterProps = {
    pageKeyword,
    startFullscreen,
    isFullScreenFiltersPage,
    isMobile,
    allCountries,
    onlineCategories,
    allCities,
    isCourseShowPage,
    isFullScreenMap
  }

  return (
    <div>
      <footer className='main-screen hide-on-booking' style={{ display: startFullscreen ? 'none' : 'block' }}>
        {showPress && <Press />}
        <div className='container'>
          <div className='row'>
            <AboutUs pages={pages} />
            <MobileReviews reviews={reviews} />
            <AboutApprentus aboutApprentus={aboutApprentus} />
            <NewsletterSubscribe subscribeUrl={subscribeUrl} />
            <FollowUs socialMediaIcons={socialMediaIcons} subscribeUrl={subscribeUrl} />
            <DesktopReviews reviews={reviews} />
            <InviteFriends inviteFriends={inviteFriends} />
            {!isLoggedIn && (
              <>
                <MobileAllCountries allCountries={allCountries} />
                <MobileAllCities allCities={allCities} />
              </>
            )}
          </div>
        </div>
      </footer>
      {((!isLoggedIn && !isMobile) || isCourseShowPage) && <UnderFooter {...underFooterProps} />}
    </div>
  )
}

Footer.propTypes = {
  showPress: PropTypes.bool,
  pages: PropTypes.array,
  aboutApprentus: PropTypes.string,
  socialMediaIcons: PropTypes.array,
  reviews: PropTypes.object,
  inviteFriends: PropTypes.object,
  subscribeUrl: PropTypes.string,
  allCountries: PropTypes.array,
  onlineCategories: PropTypes.array,
  allCities: PropTypes.array,
  isLoggedIn: PropTypes.bool
}

export default Footer
